import React from 'react';

type Props = {
    message?        : string
}

export default function LayoutAppLoading(props:Props) {


    const topHeight = gd.layout.top.height+'px';

    const topStyles = {
        height: topHeight
    };

    const mainStyles = {
        height: 'calc(100% - '+topHeight+')',
        top: topHeight
    };

    const onTopOverlayClick = (e:React.SyntheticEvent) => {
        e.stopPropagation();
        e.preventDefault();
    };

    const message = _.get(props, 'message', "Loading ...")

    return (
        <div className="ui-loading app-loading" style={mainStyles}>

            <div className="top-overlay" onClick={onTopOverlayClick} style={topStyles}></div>

            <div className="gd-loading main-area" >
                <img src={gdConfig.assetsPath+"/skin/common/loader/app-loading.gif?43"} />
                <p>{message}</p>
            </div>
        </div>
    );


}
